/* ============================================================
   VITAPOP PDP behaviours (vp-pdp-sticky-v4, 2026-07-03)
   v4: mobile sticky ATC price now mirrors the SELECTED purchase
   option (subscribe-and-save 20% off is the pre-selected default),
   read from the checked purchase-option radio's data-variant-price
   so the sticky shows £26.39 - not the £32.99 one-time price.
   Superset of v2 - preserves the proven ATC delegation, journey
   reveal, community video + review filters, and ADDS a single
   shared fade-up IntersectionObserver (.vp-fade -> .in) plus a
   science-step progress reveal. Progressive enhancement; every
   animation degrades to visible under prefers-reduced-motion.
   NEVER touches /cart/add.js - the sticky bar delegates the tap
   to the Horizon ATC so selling-plan 693680144704 stays intact.
   ============================================================ */
(function () {
  'use strict';
  var reduce = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function ready(fn){ if(document.readyState!=='loading')fn(); else document.addEventListener('DOMContentLoaded',fn); }

  /* ---------- shared fade-up entrance (single observer) ---------- */
  ready(function () {
    var els = [].slice.call(document.querySelectorAll('.vp-fade'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var d = parseInt(el.getAttribute('data-d') || '0', 10);
        setTimeout(function(){ el.classList.add('in'); }, d);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  });

  /* ---------- in-page "Add to bag" links -> scroll to buy box ---------- */
  ready(function () {
    document.querySelectorAll('[data-vpp-tobuy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('MainProduct');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });

  /* ---------- mobile sticky ATC bar (delegates to Horizon ATC) ---------- */
  ready(function () {
    var bar = document.querySelector('.vpp-satc');
    if (!bar) return;
    var root = document.getElementById('MainProduct') || document.querySelector('.template-product main') || document;
    function mainAtc(){
      return root.querySelector('add-to-cart-component button[type="submit"]') ||
             root.querySelector('button[name="add"]') ||
             root.querySelector('.product-form__submit');
    }
    var barBtn = bar.querySelector('.vpp-satc__btn');
    var barPrice = bar.querySelector('.vpp-satc__price');
    barBtn.addEventListener('click', function (e) { e.preventDefault(); var a = mainAtc(); if (a) a.click(); });

    function syncMeta(){
      // Prefer the SELECTED purchase-option radio price so the sticky mirrors
      // the subscribe-and-save default (£26.39), not the £32.99 one-time price.
      var priceText = '';
      var radios = document.querySelectorAll('input[data-radio-type][data-variant-price]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) {
          priceText = (radios[i].getAttribute('data-variant-price') || '')
            .replace(/\s*[A-Za-z]{3}\s*$/, '').trim(); // strip trailing " GBP"
          break;
        }
      }
      if (!priceText) {
        var priceEl = root.querySelector('.price__sale .price-item--sale, .price__regular .price-item, .price [class*="price-item"], .price__current, .price');
        if (priceEl) { var m = (priceEl.textContent||'').match(/[£€$]\s?\d[\d.,]*|\d[\d.,]*\s?kr/i); if (m) priceText = m[0].replace(/\s+/g,''); }
      }
      if (priceText) barPrice.textContent = priceText;
      var a = mainAtc(); if (a) { var d = a.hasAttribute('disabled'); barBtn.textContent = d ? 'Sold out' : 'Add to bag'; barBtn.toggleAttribute('disabled', d); }
    }
    // Re-sync when any purchase-option radio changes (incl. the auto-select of subscribe-and-save).
    document.addEventListener('change', function(e){ if (e.target && e.target.matches && e.target.matches('input[data-radio-type]')) syncMeta(); }, true);
    setTimeout(syncMeta, 2600);

    var footer = document.querySelector('footer');
    var ticking = false;
    function evalVis(){
      ticking = false;
      var a = mainAtc();
      if (!a) { bar.classList.remove('is-visible'); return; }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var y = window.pageYOffset;
      var anchorBottom = a.getBoundingClientRect().bottom + y;
      var footerTop = footer ? (footer.getBoundingClientRect().top + y) : 9e9;
      var show = y > anchorBottom && (footerTop - y) > vh - 40;
      bar.classList.toggle('is-visible', show);
    }
    function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(evalVis); } }
    setTimeout(syncMeta, 400); setTimeout(syncMeta, 1500);
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    root.addEventListener('change', syncMeta, true);
    evalVis();
  });

  /* ---------- collagen journey reveal (legacy 4-step, if present) ---------- */
  ready(function () {
    var j = document.querySelector('.vpp-journey');
    if (!j) return;
    var steps = [].slice.call(j.querySelectorAll('.vpp-jstep'));
    if (reduce || !('IntersectionObserver' in window)) {
      j.classList.add('is-inview'); steps.forEach(function(s){ s.classList.add('is-active'); }); return;
    }
    var fired = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting || fired) return;
        fired = true; io.disconnect(); j.classList.add('is-inview');
        steps.forEach(function (s, i) { setTimeout(function(){ s.classList.add('is-active'); }, 160 + i * 200); });
      });
    }, { threshold: 0.3 });
    io.observe(j);
  });

  /* ---------- science steps: staggered reveal (fade handled by .vp-fade) ---------- */
  /* science steps use .vp-fade with data-d, handled by the shared observer above.
     hard fallback: if the shared observer path did not run, force visible. */
  ready(function () {
    setTimeout(function () {
      var steps = [].slice.call(document.querySelectorAll('.vpp-sci__step.vp-fade'));
      steps.forEach(function (s) { if (!s.classList.contains('in')) s.classList.add('in'); });
    }, 2600);
  });

  /* ---------- community media strip (tap-to-play videos, if any) ---------- */
  ready(function () {
    var vids = [].slice.call(document.querySelectorAll('.vpp-comm__tile video'));
    if (!vids.length) return;
    function pauseAll(except){ vids.forEach(function(v){ if(v!==except && !v.paused){ v.pause(); var t=v.closest('.vpp-comm__tile'); if(t)t.classList.remove('is-playing'); } }); }
    vids.forEach(function (v) {
      var tile = v.closest('.vpp-comm__tile');
      var btn = tile && tile.querySelector('.vpp-comm__play');
      function toggle(e){ e.preventDefault(); if(v.paused){ pauseAll(v); var p=v.play(); if(p&&p.catch)p.catch(function(){}); tile.classList.add('is-playing'); } else { v.pause(); tile.classList.remove('is-playing'); } }
      if (btn) btn.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
    });
  });

  /* ---------- review filter tabs (client-side keyword filter over Judge.me) ---------- */
  ready(function () {
    var tabs = document.querySelector('.vpp-filters');
    if (!tabs) return;
    var buttons = [].slice.call(tabs.querySelectorAll('.vpp-filter'));
    var note = tabs.querySelector('.vpp-filter__note');
    function cards(){ return [].slice.call(document.querySelectorAll('#judgeme_product_reviews .jdgm-rev, #judgeme_product_reviews .jm-review-item, #judgeme_product_reviews [class*="review-item"]')); }
    function apply(kw){
      var list = cards();
      if (!list.length) { if(note) note.textContent='Filtering will apply once reviews load.'; return; }
      if(note) note.textContent='';
      if (!kw) { list.forEach(function(c){ c.style.display=''; }); return; }
      var re = new RegExp(kw, 'i');
      list.forEach(function (c) { c.style.display = re.test(c.textContent || '') ? '' : 'none'; });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        buttons.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
        apply(b.getAttribute('data-kw') || '');
      });
    });
  });
})();
